import { useQuery } from '@tanstack/react-query';
import { Control, FieldError, FieldValues, Merge, Path } from 'react-hook-form';
import { PaginatedData, RiskFactor } from '../../@types/api';
import { QUERY_KEYS } from '../../constants';
import { getData } from '../../utils/api';
import FormSelect from '../molecules/FormSelect';

type RiskFactorSelectProps<T extends FieldValues, TTransformedValues extends FieldValues | undefined = T> = {
  control: Control<T, unknown, TTransformedValues>;
  name: Path<T>;
  label?: string;
  competitionIds?: string | string[];
  error?: Merge<FieldError, (FieldError | undefined)[]>;
  multiple?: boolean;
  closeMenuOnSelect?: boolean;
};

const RiskFactorSelect = <T extends FieldValues, TTransformedValues extends FieldValues | undefined = T>({
  control,
  name,
  label,
  error,
  multiple,
  closeMenuOnSelect,
}: RiskFactorSelectProps<T, TTransformedValues>) => {
  const { data: riskFactorData } = useQuery({
    queryKey: [QUERY_KEYS.riskFactors],
    queryFn: (): Promise<PaginatedData<RiskFactor>> => getData('risk-management/risk-factors'),
  });
  return (
    <FormSelect
      label={label ?? 'Risk Factor'}
      name={name}
      control={control}
      options={riskFactorData?.items || []}
      error={error}
      multiple={multiple}
      closeOnSelect={closeMenuOnSelect}
    />
  );
};

export default RiskFactorSelect;
